// Copied into your app by RapidRailsUI (bin/rails rui:update).
// Don't edit this copy: the next update overwrites it. Fix it in the rapid_rails_ui gem.

// Server sort URL (0.94.4), no DOM access. Built from sort_url when set,
// otherwise the current page. A new order starts on page 1: keeping the page
// param showed page 3 of a different ordering.
export function sortedUrl({ base, current, column, direction, pageParam = "page" }) {
  const url = new URL(base || current, current)
  url.searchParams.set("sort", column)
  url.searchParams.set("direction", direction)
  if (pageParam) url.searchParams.delete(pageParam)
  return url.toString()
}
